import { API_URL_PRO } from "../config";

export const getMsisdnService = async (offerId, msisdn) => {
    try {
      const res = await fetch(
        `${API_URL_PRO}anonymous/help/offer/msisdn/${offerId}/${msisdn}`,
        {
          mode: "no-cors",
        }
      );
      
      return res.json();
    } catch (err) {
      return err;
    }
  };
  